













































































/* eslint-disable */
import { Component, Prop, Vue } from 'vue-property-decorator'
import ApiPlans from '@finx/web-repository/src/apis/Plans/Plans'
import { Factories } from '@finx/web-repository'
import { Auth } from '@finx/web-repository/src/services/Oidc'
import { Plan } from '@finx/web-repository/src/types/Plan'
import { IuguCreditCard, IuguSubscription } from '@finx/web-repository/src/types/Iugu'
import PagamentoStore from '@finx/web-repository/src/stores/Pagamento'
import AssinaturaStore from '@/store/Assinaturas'
import PagamentoStepsStore from '@/store/PagamentoSteps'

const component: Object = {
  store: {
    AssinaturaStore,
    PagamentoStepsStore,
    PagamentoStore,
  },
}

@Component(component)

export default class ViewPlanosAssinar extends Vue {
  stores: any = {
    assinatura: (this.$store as any).AssinaturaStore,
    steps: (this.$store as any).PagamentoStepsStore,
    pagamento: (this.$store as any).PagamentoStore,
  }

  Messages = Factories.Messages
  Validator = Factories.Validator
  paymentMethod: any = {}
  plan: any = {}
  planId: String = ''
  showAlertAssinar: Boolean = false

  get acao() {
    return this.stores.pagamento.getters.ACAO
  }

  get stepAtiva() {
    return this.stores.steps.getters.STEP_ATIVA
  }

  data() {
    return {
      planId: this.$route.params.planoId,
    }
  }

  mounted() {
    this.setAcao()
    this.getPlan()
    this.getPaymentMethod()
  }

  back() {
    this.$router.go(-1)
  }

  async getPaymentMethod() {
    const request: any = await ApiPlans.FormasDePagamento.getFormasDePagamento()
    this.paymentMethod = request.value
  }

  async getPlan() {
    const plans = await ApiPlans.Plans.getPlans()

    plans.data.map(plan => {
      if (plan.chave == this.planId) this.plan = plan
    })

    this.setAssinatura()
  }

  setAcao() {
    const acao = (this.$router as any).history.current.meta.acao
    this.stores.pagamento.commit('ACAO', acao)
  }

  setAssinatura() {
    let assinatura = {
      nome: 'Assinatura Padrão',
      token: '',
      planos: []
    }

    // @ts-ignore
    assinatura.planos = [{ planoId: this.plan.id }]

    if (this.plan.desconto && this.plan.desconto.id) {
      // @ts-ignore
      assinatura.planos[0].descontoId = this.plan.desconto.id || null
    }

    this.stores.assinatura.commit('ASSINATURA', assinatura)
  }

  showSuccessAlert(acao) {
    this.showAlertAssinar = true
  }

  logout(): void {
    this.$router.push('/logout')
  }

}
